import { put, takeLatest } from 'redux-saga/effects';
import { appStateActions } from './appState.slice';
import { masterDataActions } from 'modules/master-data/redux';
import { entityActions } from '../entity';
import { previewDataActions } from '../preview-data';
import { dataEditorActions } from 'modules/data-editor/redux';
import { archiveActions } from 'modules/archive/redux';
import { configurationActions } from 'modules/configuration/redux';
import { syncHistoryActions } from 'modules/sync-history/redux';
import { fileUploadActions } from '../file-upload';
import { userActions } from '../user';
import { dataManagementActions } from 'modules/data-management/redux';

const showLoader = function* () {
    yield put({
        type: appStateActions.showLoader.type,
        payload: true
    });
};

const showLoaderWatch = function* () {
    yield takeLatest(
        [
            masterDataActions.getMasterData.type,
            masterDataActions.fetchReviewStatus.type,
            masterDataActions.addCategory.type,
            masterDataActions.addSubCategory.type,
            masterDataActions.addIndicator.type,
            masterDataActions.updateCategory.type,
            masterDataActions.updateSubCategory.type,
            masterDataActions.updateIndicator.type,
            masterDataActions.deleteData.type,
            masterDataActions.archive.type,
            masterDataActions.refreshEntitiesByCategory.type,
            masterDataActions.getHierarchicalData.type,
            masterDataActions.searchList.type,
            masterDataActions.fetchSubCategory.type,
            masterDataActions.copyIndicator.type,
            masterDataActions.linkIndicator.type,
            masterDataActions.applyChanges.type,
            masterDataActions.getDeleteFeasibility.type,
            masterDataActions.getArchiveFeasibility.type,
            masterDataActions.isMovableSubCategoryBegin.type,
            masterDataActions.getMasterData.type,
            masterDataActions.getCloneFeasibility.type,
            masterDataActions.cloneEntity.type,
            masterDataActions.checkDuplicateIndicator.type,

            entityActions.fetchEntityDetails.type,
            entityActions.fetchCategoryDetailsForEdit.type,
            entityActions.fetchIndicatorDetailsForEdit.type,

            previewDataActions.loadPreviewData.type,
            previewDataActions.searchList.type,
            previewDataActions.updateCategory.type,
            previewDataActions.updateSubCategory.type,
            previewDataActions.updateIndicator.type,
            previewDataActions.fetchErrorCount.type,
            previewDataActions.deleteData.type,

            dataEditorActions.loadToMasterData.type,
            dataEditorActions.clearPreview.type,

            archiveActions.getHierarchicalData.type,
            archiveActions.fetchArchiveList.type,
            archiveActions.restore.type,
            archiveActions.fetchArchiveListBySearchBegin.type,

            configurationActions.fetchUploadFileLogBegin.type,

            syncHistoryActions.fetchSyncLogs.type,

            configurationActions.fetchFrequentlyUsed.type,
            configurationActions.deleteData.type,
            configurationActions.fetchTrendingData.type,
            configurationActions.reOrderData.type,
            configurationActions.fetchStaticIndicators.type,
            configurationActions.reorderTrendingData.type,
            configurationActions.deleteTrendingData.type,
            configurationActions.fetchGeographyOverview.type,
            configurationActions.fetchKeyIndicators.type,
            configurationActions.getCategories.type,
            configurationActions.toggleHierarchicalDataExpansion.type,
            configurationActions.saveIndicatorAdd.type,
            configurationActions.fetchWhatsNew.type,
            configurationActions.saveTrendingData.type,
            configurationActions.deleteWhatsNewData.type,
            configurationActions.saveWhatsNewIndicator.type,
            configurationActions.reOrderWhatsNew.type,
            configurationActions.saveWhatsNewLink.type,
            configurationActions.uploadFile.type,
            configurationActions.addIndicatorSource.type,
            configurationActions.updateIndicatorSource.type,
            configurationActions.deleteIndicatorSource.type,
            configurationActions.saveVideoLink.type,
            configurationActions.fetchVideoLink.type,
            configurationActions.deleteVideoLink.type,
            configurationActions.saveVideoLink.type,
            configurationActions.updateVideoLink.type,

            fileUploadActions.fetchUploadStatus.type,
            fileUploadActions.getSyncDetails.type,

            userActions.getUserInfo.type,

            dataManagementActions.fetchCompanyFootprint.type,
            dataManagementActions.updateCompanyFootprint.type
        ],
        showLoader
    );
};

const hideLoader = function* () {
    yield put({
        type: appStateActions.showLoader.type,
        payload: false
    });
};

const hideLoaderWatch = function* () {
    yield takeLatest(
        [
            masterDataActions.getMasterDataSuccess.type,
            masterDataActions.getMasterDataError.type,
            masterDataActions.toggleExpansionSuccess.type,
            masterDataActions.toggleExpansionFailed.type,
            masterDataActions.fetchReviewStatusSuccess.type,
            masterDataActions.fetchReviewStatusFailed.type,
            masterDataActions.addCategorySuccess.type,
            masterDataActions.addCategoryFailed.type,
            masterDataActions.addSubCategorySuccess.type,
            masterDataActions.addSubCategoryFailed.type,
            masterDataActions.addIndicatorSuccess.type,
            masterDataActions.addIndicatorFailed.type,
            masterDataActions.updateCategorySuccess.type,
            masterDataActions.updateCategoryFailed.type,
            masterDataActions.updateSubCategorySuccess.type,
            masterDataActions.updateSubCategoryFailed.type,
            masterDataActions.updateIndicatorSuccess.type,
            masterDataActions.updateIndicatorFailed.type,
            masterDataActions.deleteDataSuccess.type,
            masterDataActions.deleteDataError.type,
            masterDataActions.archiveSuccess.type,
            masterDataActions.archiveFailed.type,
            masterDataActions.refreshEntitiesByCategorySuccess.type,
            masterDataActions.refreshEntitiesByCategoryFailed.type,
            masterDataActions.getHierarchicalDataSuccess.type,
            masterDataActions.getHierarchicalDataError.type,
            masterDataActions.toggleHierarchicalDataExpansionSuccess.type,
            masterDataActions.toggleHierarchicalDataExpansionFailed.type,
            masterDataActions.searchListSuccess.type,
            masterDataActions.searchListError.type,
            masterDataActions.fetchSubCategorySuccess.type,
            masterDataActions.fetchSubCategoryFailed.type,
            masterDataActions.copyIndicatorSuccess.type,
            masterDataActions.copyIndicatorFailed.type,
            masterDataActions.linkIndicatorFailed.type,
            masterDataActions.linkIndicatorSuccess.type,
            masterDataActions.applyChangesSuccess.type,
            masterDataActions.applyChangesFailed.type,
            masterDataActions.getDeleteFeasibilitySuccess.type,
            masterDataActions.getDeleteFeasibilityFailed.type,
            masterDataActions.getArchiveFeasibilitySuccess.type,
            masterDataActions.getArchiveFeasibilityFailed.type,
            masterDataActions.isMovableSubCategorySuccess.type,
            masterDataActions.isMovableSubCategoryError.type,
            masterDataActions.getMasterDataSuccess.type,
            masterDataActions.getMasterDataError.type,
            masterDataActions.getCloneFeasibilitySuccess.type,
            masterDataActions.getCloneFeasibilityFailed.type,
            masterDataActions.cloneEntitySuccess.type,
            masterDataActions.cloneEntityFailed.type,
            masterDataActions.checkDuplicateIndicatorSuccess.type,
            masterDataActions.checkDuplicateIndicatorFailed.type,

            entityActions.fetchEntityDetailsSuccess.type,
            entityActions.fetchEntityDetailsError.type,
            entityActions.fetchCategoryDetailsForEditSuccess.type,
            entityActions.fetchCategoryDetailsForEditError.type,
            entityActions.fetchIndicatorDetailsForEditSuccess.type,
            entityActions.fetchIndicatorDetailsForEditError.type,

            previewDataActions.loadPreviewDataSuccess.type,
            previewDataActions.loadPreviewDataError.type,
            previewDataActions.searchListSuccess.type,
            previewDataActions.searchListError.type,
            previewDataActions.updateCategorySuccess.type,
            previewDataActions.updateCategoryFailed.type,
            previewDataActions.updateSubCategorySuccess.type,
            previewDataActions.updateSubCategoryFailed.type,
            previewDataActions.updateIndicatorSuccess.type,
            previewDataActions.updateIndicatorFailed.type,
            previewDataActions.fetchErrorCountSuccess.type,
            previewDataActions.fetchErrorCountFailed.type,
            previewDataActions.deleteDataSuccess.type,
            previewDataActions.deleteDataError.type,
            previewDataActions.toggleExpansionSuccess.type,
            previewDataActions.toggleExpansionFailed.type,

            dataEditorActions.loadToMasterDataSuccess.type,
            dataEditorActions.loadToMasterDataFailed.type,
            dataEditorActions.clearPreviewSuccess.type,
            dataEditorActions.clearPreviewFailed.type,

            archiveActions.getHierarchicalDataSuccess.type,
            archiveActions.getHierarchicalDataError.type,
            archiveActions.toggleHierarchicalDataExpansionSuccess.type,
            archiveActions.toggleHierarchicalDataExpansionFailed.type,
            archiveActions.fetchArchiveListSuccess.type,
            archiveActions.fetchArchiveListError.type,
            archiveActions.restoreSuccess.type,
            archiveActions.restoreFailed.type,
            archiveActions.fetchArchiveListBySearchSuccess.type,
            archiveActions.fetchArchiveListBySearchError.type,

            configurationActions.fetchUploadFileLogSuccess.type,
            configurationActions.fetchUploadFileLogError.type,

            syncHistoryActions.fetchSyncLogsSuccess.type,
            syncHistoryActions.fetchSyncLogsFailed.type,

            configurationActions.fetchFrequentlyUsedSuccess.type,
            configurationActions.fetchFrequentlyUsedFailed.type,
            configurationActions.deleteDataSuccess.type,
            configurationActions.deleteDataError.type,
            configurationActions.fetchTrendingDataFailed.type,
            configurationActions.fetchTrendingDataSuccess.type,
            configurationActions.reOrderDataSuccess.type,
            configurationActions.reOrderDataFailed.type,
            configurationActions.reorderTrendingDataFailed.type,
            configurationActions.reorderTrendingDataSuccess.type,
            configurationActions.deleteTrendingDataError.type,
            configurationActions.deleteTrendingDataSuccess.type,
            configurationActions.fetchStaticIndicatorsSuccess.type,
            configurationActions.fetchStaticIndicatorsFailed.type,
            configurationActions.getCategoriesFailed.type,
            configurationActions.getCategoriesSuccess.type,
            configurationActions.toggleHierarchicalExpansionFailed.type,
            configurationActions.toggleHierarchicalExpansionSuccess.type,
            configurationActions.fetchGeographyOverviewSuccess.type,
            configurationActions.fetchGeographyOverviewFailed.type,
            configurationActions.fetchKeyIndicatorsSuccess.type,
            configurationActions.fetchKeyIndicatorsFailed.type,
            configurationActions.toggleHierarchicalDataCollapse.type,
            configurationActions.saveIndicatorAddSuccess.type,
            configurationActions.saveIndicatorAddFailed.type,
            configurationActions.saveTrendingDataSuccess.type,
            configurationActions.saveTrendingDataFailed.type,
            configurationActions.fetchWhatsNewSuccess.type,
            configurationActions.fetchWhatsNewFailed.type,
            configurationActions.deleteWhatsNewSuccess.type,
            configurationActions.deleteWhatsNewError.type,
            configurationActions.saveWhatsNewIndicatorSuccess.type,
            configurationActions.saveWhatsNewIndicatorFailed.type,
            configurationActions.reOrderWhatsNewSuccess.type,
            configurationActions.reOrderWhatsNewFailed.type,
            configurationActions.saveWhatsNewLinkSuccess.type,
            configurationActions.saveWhatsNewLinkFailed.type,
            configurationActions.uploadFileFailed.type,
            configurationActions.uploadFileSuccess.type,
            configurationActions.addIndicatorSourceSuccess.type,
            configurationActions.addIndicatorSourceFailed.type,
            configurationActions.updateIndicatorSourceFailed.type,
            configurationActions.updateIndicatorSourceSuccess.type,
            configurationActions.deleteIndicatorSourceFailed.type,
            configurationActions.deleteIndicatorSourceSuccess.type,
            configurationActions.saveVideoLinkSuccess.type,
            configurationActions.saveVideoLinkFailed.type,
            configurationActions.fetchVideoLinkSuccess.type,
            configurationActions.fetchVideoLinkFailed.type,
            configurationActions.deleteVideoLinkSuccess.type,
            configurationActions.deleteVideoLinkFailed.type,
            configurationActions.saveVideoLinkFailed.type,
            configurationActions.saveVideoLinkSuccess.type,
            configurationActions.updateVideoLinkSuccess.type,
            configurationActions.updateVideoLinkFailed.type,

            fileUploadActions.getSyncDetailsSuccess.type,
            fileUploadActions.getSyncDetailsFailed.type,
            fileUploadActions.fetchUploadStatusSuccess.type,
            fileUploadActions.fetchUploadStatusFailed.type,

            userActions.getUserInfoSuccess.type,
            userActions.getUserInfoError.type,

            dataManagementActions.fetchCompanyFootprintSuccess.type,
            dataManagementActions.fetchCompanyFootprintFailed.type,
            dataManagementActions.updateCompanyFootprintSuccess.type,
            dataManagementActions.updateCompanyFootprintFailed.type
        ],
        hideLoader
    );
};

export { showLoaderWatch, hideLoaderWatch };
